import React, { useMemo } from 'react';
import { FormGroup, Input } from 'src/components/ui';

function StaticField(props) {
  const {
    formData,
    disabled,
    schema: { title },
    uiSchema: { 'ui:readonly': readonly, 'ui:useSpan': useSpan, 'ui:onEmptyMessage': onEmptyMessage },
    required,
  } = props;

  const content = useMemo(() => {
    if (formData) return formData;
    if (onEmptyMessage) return onEmptyMessage;

    return '---';
  }, [formData, onEmptyMessage]);

  return (
    <FormGroup disabled={readonly || disabled}>
      {title ? (
        <>
          <label className="control-label" htmlFor="root_preferredBranchId">
            {title}
            {required ? <span className="required">*</span> : null}
          </label>
        </>
      ) : null}
      {useSpan ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <span>{content}</span>
        </div>
      ) : (
        <Input plaintext value={content} readOnly />
      )}
    </FormGroup>
  );
}

export default StaticField;
